module.exports = __webpack_public_path__ + "323e143642ec1b368cf855ea0e462e77.svg";